import React, { useContext, useState } from "react";
import { set, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import AuthContainer from "../../containers/Auth";
import AuthInputText from "../../components/AuthInput";
import { useNavigate } from "react-router-dom";
import { TokenContext } from "../../service/context/tokencontent";
import CustomModal from "../../components/Modal";
import { AUTH_URL, } from "../../common/common";
import { validationSchema } from "../../service/validation/gstDetails";
import { ApiService } from "../../service/api.service";
import { json } from "stream/consumers";

const GSTDetails = () => {
  const apiService = new ApiService();
  const { setToken, token } = useContext(TokenContext)!;
  const [isModalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  const businessType = localStorage.getItem("businessType");
  let parsedBusinessType = businessType ? JSON.parse(businessType) : null;
  let entityId = localStorage.getItem("entity_id");
  let gst = localStorage.getItem("gst-mot") || "";
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    watch,
  } = useForm({
    defaultValues: {
      gstNumber: gst,
      legalName: "KITTI",
      businessAddress: "Block Q, No: 24/20, 1’st Floor, Tirumangalam Rd, Block Q, Agathiyar Nagar, Anna Nagar, Chennai, Tamil Nadu 600049",
      panNumber: "AAAPA1234A",
      msmeIncNumber: "L12345MH2023PLC000789"
    },
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data: any) => {
    try {
      // Simulate API call with a delay
      // Ensure parsedBusinessType is an array before mapping
      // let businessIds = Array.isArray(parsedBusinessType) ? parsedBusinessType.map((item: any) => item.id) : [];

      console.log(data.businessAddress, "k");
      let Jdata = JSON.stringify(data.businessAddress);
      console.log(Jdata, "Jdata");
      // Ensure businessId[0] exists before assigning
      let newData = {
        ...data,
        businessIds: parsedBusinessType,  // Set null if empty
        type: "Gst",
        businessAddress: Jdata,
        entityId: entityId,
      };


      // console.log("newData", "newData");
      const response: any = await apiService.postApi(`${AUTH_URL}/business/store-route`, newData);
      if (response.status === "200") {
        const tokenValue = "token for fun"; // Simulated token
        // localStorage.setItem("user_data_motsop", JSON.stringify(response.body.data));
        localStorage.setItem("motosop", tokenValue); // Save token to localStorage
        setToken(tokenValue); // Update the context
        localStorage.removeItem("gst-mot")
        navigate('/dashboard')

      }
    } catch (error) {
      console.error("GST Verification Error:", error);
      // alert("Failed to verify GST Number. Please try again.");
    }
  };

  const gstNumberValue = watch("gstNumber", "");
  const organisationValue = watch("legalName", "");
  const addressValue = watch("businessAddress", "");
  const incorporationValue = watch("msmeIncNumber", "");
  const panNoValue = watch("panNumber", "");

  return (
    <AuthContainer>
      <div className="flex w-full rounded-[21.25px] min-h-[90vh] bg-white font-poppins">
        {/* <div className="bg-[#D9D9D9] rounded-[21.25px] w-full"></div> */}
        <div className="w-full">
          <div className="md:mx-[8rem]  ">

            <br />
            <div className="h-[100px] w-[239px] bg-[#D9D9D9] flex items-center justify-center">
              logo
            </div>
            <p className="font-[700] text-[20px] font-poppins  track-[1%]">
              Welcome aboard 👋
            </p>
            <p className="font-[400] font-poppins text-[16px] track-[1%] text-[#313957]">
              Business KYC
            </p>
            <br />
            {/* Form */}
            <form onSubmit={handleSubmit(onSubmit)}>
              <AuthInputText
                label="GST Number"
                value={gstNumberValue}
                errors={errors}
                placeholder="Enter GST Number"
                autoComplete="one-time-code"
                name="gstNumber"
                type="text"
                maxLength={15}
                register={register}
                verified={true}
              />
              <AuthInputText
                label="Organisation  Name"
                value={organisationValue}
                errors={errors}
                placeholder="Enter Organisation Name"
                autoComplete="one-time-code"
                name="legalName"
                type="text"
                register={register}
              />
              <AuthInputText
                label="Address  "
                value={addressValue}
                errors={errors}
                placeholder="Enter Address"
                autoComplete="one-time-code"
                name="businessAddress"
                type="text"
                register={register}
              />
              <AuthInputText
                label="Incorporation / MSME Number"
                value={incorporationValue}
                errors={errors}
                placeholder="Enter Incorporation / MSME Number"
                autoComplete="one-time-code"
                name="msmeIncNumber"
                type="text"
                register={register}
              />
              <AuthInputText
                label="Pan No"
                value={panNoValue}
                errors={errors}
                placeholder="Enter Pan No"
                autoComplete="one-time-code"
                name="panNumber"
                type="text"
                maxLength={10}
                register={register}
              />

              {/* Submit button */}
              <div className="mx-[20px]">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="mt-4 p-2 w-full h-[50px] font-[400] text-[16px] leading-[22.96px] tracking-[1%] bg-[#444FBD] rounded-[20px] text-white rounded"
                >
                  {isSubmitting ? "Submitting..." : "Continue"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

    </AuthContainer>
  );
};


export default GSTDetails;
